import React from "react";

import {
  MenuToggle
} from "@patternfly/react-core";

const AppearanceToggle = ({
  toggleRef,
  isOpen,
  toggle,
  colorScheme,
}) => {
  const Icon = colorScheme?.icon;

  return (
    <>
    <MenuToggle
      ref={toggleRef}
      isExpanded={isOpen}
      onClick={toggle}
      aria-label="Appearance"
    >
      {Icon &&
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Icon size={16} />
          </div>
      }
    </MenuToggle>
    </>
  );
};

export default AppearanceToggle;